export default "__VITE_ASSET__lo1LJt8Y__"